import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import Switch, { Case } from 'react-switch-case';
import ExcelJS from 'exceljs';
import FileSaver from "file-saver";

// import other components within the same project here

import Localization from "../Localization.jsx"

import RootPage from "../pages/RootPage.jsx"
import RetrieverBar from "../views/retriever/RetrieverBar.jsx"
import SubmissionDetail from "../views/retriever/SubmissionDetail.jsx"

import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Icon,
  Card,
  CardContent,
  Grid,
  Divider,
  Typography,
} from '@material-ui/core';

const RET_VIEW_DATES = 0;
const RET_VIEW_SUBMISSION_GROUPS = 1;
const RET_VIEW_SUBMISSION_HISTORY = 2;

class RetrieverPage extends React.Component {
  static RET_VIEW_DATES() {
    return RET_VIEW_DATES;
  }

  static RET_VIEW_SUBMISSION_GROUPS() {
    return RET_VIEW_SUBMISSION_GROUPS;
  }

  static RET_VIEW_SUBMISSION_HISTORY() {
    return RET_VIEW_SUBMISSION_HISTORY;
  }

  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      status: RET_VIEW_DATES,
      currentLocaleId: this.props.localeData.id,
      currentDate: "",
      currentSubmissionId: 0,
      submissionGroupList: [],
      submissionList: [],
      maxHeight: 0,
      selectedIndex: -1,
    };
    autoBind(this);

    this.refresh();
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    let boundingRect = this.refs.retrieverBar.refs.div.getBoundingClientRect();
    let height = window.innerHeight - (boundingRect.y + window.scrollY + boundingRect.height);
    this.setState({
      maxHeight: height,
    });
    this.state.maxHeight = height;
  }

  s2ab(s){
    let buf = new ArrayBuffer(s.length);
    let view = new Uint8Array(buf);
    for (var i=0; i!=s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }

  refresh() {
    switch(this.state.status) {
      case RET_VIEW_DATES:
        console.log(this.props.root);
        this.props.root.refs.API.request("get_submission_groups_by_locale", { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId }, this.getSubmissionGroupByLocaleOK, this.getSubmissionGroupByLocaleFailed);
        break;
      case RET_VIEW_SUBMISSION_GROUPS:
        this.props.root.refs.API.request("get_submission_list_by_locale_and_date", { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId, date:this.state.currentDate }, this.getSubmissionGroupByDateOK, this.getSubmissionGroupByDateFailed);
        break;
      case RET_VIEW_SUBMISSION_HISTORY:
        break;
      default:
        break;
    }
  }

  getSubmissionGroupByLocaleOK(res) {
    console.log(res.body['result']);
    this.setState({submissionGroupList: res.body['result']});
  }

  getSubmissionGroupByLocaleFailed(err) {
    console.log("get submission group by locale failed");
  }

  getSubmissionGroupByDateOK(res) {
    this.setState({submissionList:res.body['result']});
  }

  getSubmissionGroupByDateFailed(err) {
    console.log("get submission group by date failed");
  }

  handleDateClicked(date, changeHistory=true) {
    this.setState({
      status: RET_VIEW_SUBMISSION_GROUPS,
      currentDate: date,
      selectedIndex: -1,
    });
    this.state.status = RET_VIEW_SUBMISSION_GROUPS;
    this.state.currentDate = date;
    this.state.selectedIndex = -1;
    this.refresh();

    if (changeHistory) {
      this.props.root.pushHistory("retriever/date");
    }
  }

  handleSubmissionClicked(index, submission_id) {
    this.setState({
      currentSubmissionId: submission_id,
      selectedIndex: index,
    });
    this.state.currentSubmissionId = submission_id;
    this.state.selectedIndex = index;
    this.refs.submissionDetail.setState({ submissionId: submission_id });
    this.refs.submissionDetail.state.submissionId = submission_id;
    this.refs.submissionDetail.refresh();
  }

  handleBackButtonClicked() {
    if (this.state.status == RET_VIEW_DATES) {
      this.props.root.changeStatus(this.props.root.STATUS_VIEW_LOCALE_LIST())
    }
    else if (this.state.status == RET_VIEW_SUBMISSION_GROUPS) {
      this.setState({
        status: RET_VIEW_DATES,
      })
      this.state.status = RET_VIEW_DATES;
      this.refs.submissionDetail.setState({ stageList: [] });
    }
    else if (this.state.status == RET_VIEW_SUBMISSION_HISTORY) {
      this.setState({
        status: RET_VIEW_SUBMISSION_GROUPS,
      })
      this.state.status = RET_VIEW_SUBMISSION_GROUPS;
      this.refs.submissionDetail.setState({ stageList: [] });
    }
  }

  handleForwardButtonClicked() {
    if (this.state.status == RET_VIEW_DATES) {
      this.handleDateClicked(this.state.currentDate, false);
    }
  }

  exportAnswer() {
    this.getAllAnswer();
  }

  getAllAnswer() {
    let requestObj = {
      school_id: this.props.root.getMySchoolId(),
      locale_id: this.state.currentLocaleId,
    };

    this.props.root.refs.API.request("get_all_answers_for_export_by_locale", requestObj, this.getAllAnswerOK, this.getAllAnswerFailed);
  }

  getAllAnswerOK(res) {
    console.log("Start processing response...");

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('ExportedAnswers');

    // Add headers
    worksheet.addRow(["Student", "Question", "Answer", "Result", "Time"]);

    let exportList = Object.values(res.body['result']['export_list']);

    for (let i = 0; i < exportList.length; i++) {
      console.log("Processing exportList item number: " + (i+1) + "/" + exportList.length);

      let userObjects = Object.values(exportList[i]);

      for (let j = 0; j < userObjects.length; j++) {
        console.log("Processing userObjects item number: " + (j+1) + "/" + userObjects.length);

        let row = userObjects[j];
        let answerList = row['answer_list'];

        for (let k = 0; k < answerList.length; k++) {
          console.log("Processing answerList item number: " + (k+1) + "/" + answerList.length);

          let row2 = answerList[k];
          let rowData = [
            row['user_name'],
            row2['content']
          ];

          if (row2['kind'] == 2) {
            let ansIndex = row2['answer'];
            let ansArr = JSON.parse(row2['payload']).ans_arr;
            rowData.push(ansArr[ansIndex]['text']);

            let isCorrect = ansArr[ansIndex]['is_correct'];
            rowData.push(isCorrect == 1 ? "Correct" : "Wrong");
          }
          else if (row2['kind'] == 4) {
            let BASE_URL = "https://vrhost.ev-cuhk.net/~evvr/uploads/";
            let ansPath = row2['file_path'];
            rowData.push(BASE_URL + ansPath);
            rowData.push("N/A");
          }

          rowData.push(row2['update_time']);
          worksheet.addRow(rowData);
        }
      }
    }

    // Generate and save file
    const fileName = this.props.localeData['locale_name'].replace(/\s+/g, '');
    console.log("Saving file with name: " + fileName);
    
    workbook.xlsx.writeBuffer().then(buffer => {
      FileSaver.saveAs(
        new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 
        `${fileName}.xlsx`
      );
    });
    
    console.log("Finished processing response and saved file.");
  }
  
  
  
  

  getAllAnswerFailed(err) {
    console.log("get all answer failed " + err);
  }

  render() {
    return (
      <div>
        <RetrieverBar root={this.props.root} parent={this} ref="retrieverBar"/>
        <Grid container>
          <Grid item xs={8} sm={3}>
            <Switch condition={this.state.status}>
              <Case value={RET_VIEW_DATES}>
                <List style={{maxHeight:this.state.maxHeight, overflow:'auto', padding:'0'}}>
                  <ListItem>
                    <ListItemText>
                      <Typography variant="h6">{this.props.localeData['locale_name']}</Typography>
                    </ListItemText>
                  </ListItem>
                  <Divider variant="middle"/>
                  <If condition={this.state.submissionGroupList.length == 0}>
                    <Then>
                      <Card style={{margin: "10px"}}>
                        <CardContent>
                          {Localization.strings.EMPTY_SUBMISSION_REMINDER}
                        </CardContent>
                      </Card>
                    </Then>
                    <Else>
                      {this.state.submissionGroupList.map( (row, i) => {
                        return (
                          <ListItem button key={i} onClick={()=>this.handleDateClicked(row['submission_start_time'])}>
                            <ListItemIcon>
                              <Icon>today</Icon>
                            </ListItemIcon>
                            <ListItemText
                              primary={row['submission_start_time'].split(" ")[0]}
                              secondary={Localization.strings.SUBMISSION_S + ": " + row['count']}
                            />
                          </ListItem>
                        );
                      })}
                    </Else>
                  </If>
                </List>
              </Case>
              <Case value={RET_VIEW_SUBMISSION_GROUPS}>
                <List style={{maxHeight:this.state.maxHeight, overflow:'auto', padding:'0'}}>
                  <ListItem>
                    <ListItemText>
                      <Typography variant="h6">{this.state.currentDate.split(" ")[0]}</Typography>
                    </ListItemText>
                  </ListItem>
                  <Divider variant="middle"/>
                  {this.state.submissionList.map( (row, i) => {
                    return (
                      <ListItem
                        button
                        key={i}
                        onClick={()=>this.handleSubmissionClicked(i ,row['id'])}
                        selected={i == this.state.selectedIndex}
                      >
                        <ListItemIcon>
                          <Icon>face</Icon>
                        </ListItemIcon>
                        <ListItemText
                          primary={row['user_name']}
                          secondary={Localization.strings.TIME + ": " + row['submission_start_time'].split(" ")[1]}
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </Case>
            </Switch>
          </Grid>
          <Grid item xs={8} sm={9}>
            <SubmissionDetail root={this.props.root} parent={this} ref="submissionDetail"
              maxHeight={this.state.maxHeight}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default RetrieverPage;
